import React from 'react'
import styled from 'styled-components'

import Button from '../../Button'
import ButtonGroup from '../../ButtonGroup'

interface HeaderControlProps {
  controls: Array<React.ReactElement>
}
const Wrapper = styled.div``

const HeaderControls = (props: HeaderControlProps): React.ReactElement => {
  const { controls = [] } = props

  return (
    <Wrapper className="d-flex justify-content-end">
      <ButtonGroup xs secondary nowrap>
        {controls.map((control) =>
          React.isValidElement(control) ? (
            control
          ) : (
            <Button
              key={control.key}
              {...(control as unknown as Record<string, unknown>)}
            />
          ),
        )}
      </ButtonGroup>
    </Wrapper>
  )
}

export default HeaderControls
